import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/international/home',
    name: 'InternationalHome',
    component: () => import('../views/international/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/news/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/news/international',
    name: 'InternationalNews',
    component: () => import('../views/news/international-index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/news/international/add',
    name: 'InternationalNewsAdd',
    component: () => import('../views/news/international-add.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/news/international/edit/:id',
    name: 'InternationalNewsEdit',
    component: () => import('../views/news/international-edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/upload',
    name: 'Upload',
    component: () => import('../views/upload/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/users/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users/international',
    name: 'InternationalUsers',
    component: () => import('../views/users/international.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/express-companies',
    redirect: '/settings/express-companies'
  },
  {
    path: '/settings/express-companies',
    name: 'SettingsExpressCompanies',
    component: () => import('../views/settings/express-companies.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/roles',
    name: 'Roles',
    component: () => import('../views/roles/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/roles/add',
    name: 'RoleAdd',
    component: () => import('../views/roles/add.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/roles/edit/:id',
    name: 'RoleEdit',
    component: () => import('../views/roles/edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admins',
    name: 'Admins',
    component: () => import('../views/admins/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admins/add',
    name: 'AdminAdd',
    component: () => import('../views/admins/add.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admins/edit/:id',
    name: 'AdminEdit',
    component: () => import('../views/admins/edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/news/add',
    name: 'NewsAdd',
    component: () => import('../views/news/add.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/news/edit/:id',
    name: 'NewsEdit',
    component: () => import('../views/news/edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/products/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/products/international',
    name: 'InternationalProducts',
    component: () => import('../views/products/international-index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/erp/products',
    name: 'ErpProducts',
    component: () => import('../views/erp/products/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('../views/orders/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/international',
    name: 'InternationalOrders',
    component: () => import('../views/orders/international-index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/international/detail/:id',
    name: 'InternationalOrderDetail',
    component: () => import('../views/orders/international-detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/create',
    name: 'OrderCreate',
    component: () => import('../views/orders/create.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/detail/:id',
    name: 'OrderDetail',
    component: () => import('../views/orders/detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/pending',
    name: 'PendingOrders',
    component: () => import('../views/orders/pending.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/processing',
    name: 'ProcessingOrders',
    component: () => import('../views/orders/processing.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/completed',
    name: 'CompletedOrders',
    component: () => import('../views/orders/completed.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/shipped',
    name: 'ShippedOrders',
    component: () => import('../views/orders/shipped.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/manual-status',
    name: 'ManualStatusOrders',
    component: () => import('../views/orders/manual-status.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mobile/orders/manual-status',
    name: 'MobileManualStatusOrders',
    component: () => import('../views/mobile/orders/manual-status.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/paid-deposit',
    name: 'PaidDepositOrders',
    component: () => import('../views/orders/paid-deposit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/product-types',
    name: 'ProductTypes',
    component: () => import('../views/products/types.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/product-types/international',
    name: 'InternationalProductTypes',
    component: () => import('../views/products/international-types.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/settings/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/express-companies',
    name: 'SettingsExpressCompanies',
    component: () => import('../views/settings/express-companies.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/platforms',
    name: 'SettingsPlatforms',
    component: () => import('../views/settings/platforms.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/stores',
    name: 'Stores',
    component: () => import('../views/stores/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mobile/orders/create',
    name: 'MobileOrderCreate',
    component: () => import('../views/mobile/orders/create.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mobile/signature',
    name: 'MobileSignature',
    component: () => import('@/views/mobile/SignaturePad.vue'),
    meta: { title: '签名', hidden: true, requiresAuth: false }
  },
  {
    path: '/settings/stock-adjustment',
    name: 'SettingsStockAdjustment',
    component: () => import('../views/settings/stock-adjustment.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/stock-sync-record',
    name: 'SettingsStockSyncRecord',
    component: () => import('../views/settings/stock-sync-record.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/photo-management',
    name: 'SettingsPhotoManagement',
    component: () => import('../views/settings/photo-management.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/permissions',
    name: 'Permissions',
    component: () => import('../views/permissions/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/permissions/manage/:id',
    name: 'PermissionManage',
    component: () => import('../views/permissions/manage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/finance/income',
    name: 'FinanceIncome',
    component: () => import('../views/finance/income.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/finance/reports',
    name: 'FinanceReports',
    component: () => import('../views/finance/reports.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inventory',
    name: 'InventoryManagement',
    component: () => import('../views/inventory/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/manual-sync-record',
    name: 'ManualSyncRecord',
    component: () => import('../views/manual-sync-record/index.vue'),
    meta: { requiresAuth: true }
  },
  // {
  //   path: '/inventory',
  //   name: 'InventoryManagement',
  //   component: () => import('../views/inventory/index.vue'),
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: '/manual-sync-record',
  //   name: 'ManualSyncRecord',
  //   component: () => import('../views/manual-sync-record/index.vue'),
  //   meta: { requiresAuth: true }
  // },

  // SKU管理路由已移除，因为SKU管理功能已从库存管理页面移除
  {
    path: '/customer-profile',
    name: 'CustomerProfile',
    component: () => import('../views/CustomerProfile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/front-data',
    name: 'FrontData',
    component: () => import('../views/FrontData.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/international/customer-profile',
    name: 'InternationalCustomerProfile',
    component: () => import('../views/international/CustomerProfile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/international/front-data',
    name: 'InternationalFrontData',
    component: () => import('../views/international/FrontData.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/image-upload',
    name: 'ImageUpload',
    component: () => import('../views/ImageUpload.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: () => import('../views/tasks/index.vue'),
    meta: { requiresAuth: true, permission: 'task:view' }
  },
  {
    path: '/tasks/users',
    name: 'TaskUsers',
    component: () => import('../views/tasks/UserTargets.vue'),
    meta: { requiresAuth: true, permission: 'task:view' }
  },
  {
    path: '/tasksuu',
    name: 'TasksUU',
    component: () => import('../views/tasks/UserTargets.vue'),
    meta: { requiresAuth: true, permission: 'task:view' }
  },

  {
    path: '/freights',
    name: 'Freights',
    component: () => import('../views/freights/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/freights/ship-orders',
    name: 'ShipOrders',
    component: () => import('../views/freights/ship-orders/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/freights/ship-orders/add',
    name: 'ShipOrdersAdd',
    component: () => import('../views/freights/ship-orders/add.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/freights/ship-orders/edit/:id',
    name: 'ShipOrdersEdit',
    component: () => import('../views/freights/ship-orders/edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/freights/ship-orders/detail/:id',
    name: 'ShipOrdersDetail',
    component: () => import('../views/freights/ship-orders/detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/freights/preview/:id',
    name: 'FreightPreviewH5',
    component: () => import('../views/freights/preview.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/freights/preview',
    name: 'FreightPreviewH5Query',
    component: () => import('../views/freights/preview.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/freights',
    name: 'FreightPreviewH5Plain',
    component: () => import('../views/freights/preview.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/freights/notify-targets',
    name: 'FreightNotifyTargets',
    component: () => import('../views/freights/NotifyTargets.vue'),
    meta: { requiresAuth: true, permission: 'freight:view' }
  },
  {
    path: '/orders/international/pending',
    name: 'InternationalOrdersPending',
    component: () => import('../views/orders/international-pending.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/international/processing',
    name: 'InternationalOrdersProcessing',
    component: () => import('../views/orders/international-processing.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/international/shipped',
    name: 'InternationalOrdersShipped',
    component: () => import('../views/orders/international-shipped.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/international/completed',
    name: 'InternationalOrdersCompleted',
    component: () => import('../views/orders/international-completed.vue'),
    meta: { requiresAuth: true }
  },
  // 设置 - 翻译Key管理
  {
    path: '/settings/translate-keys',
    name: 'SettingsTranslateKeys',
    component: () => import('../views/settings/translate-keys.vue'),
    meta: { requiresAuth: true }
  },
  // 设置 - 同步任务管理
  {
    path: '/settings/sync-tasks',
    name: 'SettingsSyncTasks',
    component: () => import('../views/settings/sync-tasks.vue'),
    meta: { requiresAuth: true }
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  
  // 如果访问登录页面
  if (to.path === '/login') {
    if (token) {
      // 已登录用户访问登录页，跳转到首页
      next('/')
    } else {
      // 未登录用户，允许访问登录页
      next()
    }
    return
  }
  
  // 如果访问需要认证的页面
  if (to.meta.requiresAuth) {
    if (!token) {
      // 需要登录但没有token，跳转到登录页
      next('/login')
    } else {
      // 有token，允许访问
      next()
    }
    return
  }
  
  // 其他情况，允许访问
  next()
})

export default router
